import AdsRules from './ads-rules'

const adsRules = new AdsRules()
adsRules.init()
